import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { content } from '../data/content';
import { Button } from './ui/Button';
import { Icon } from './ui/Icon';
import { Reveal } from './ui/Reveal';

export const CTA = () => {
  const { language } = useLanguage();
  const t = content[language];
  return (
    <section className="py-14 sm:py-20">
      <div className="container">
        <Reveal>
          <div
            className="relative overflow-hidden rounded-[2rem] sm:rounded-[2.5rem] border p-6 sm:p-10 lg:p-14 text-white"
            style={{
              background:
                'radial-gradient(ellipse at top left, color-mix(in oklab, var(--accent) 50%, transparent) 0%, transparent 50%), linear-gradient(135deg, color-mix(in oklab, var(--brand) 95%, black) 0%, color-mix(in oklab, var(--brand) 60%, var(--accent)) 100%)',
              borderColor: 'transparent',
            }}
          >
            <div className="absolute inset-0 bg-dotgrid opacity-10 [mask-image:radial-gradient(ellipse_60%_60%_at_50%_50%,#000,transparent)]" />
            <div className="relative grid lg:grid-cols-12 items-center gap-8">
              <div className="lg:col-span-8">
                {t.cta.eyebrow && (
                  <p className="eyebrow text-white/60 mb-3">{t.cta.eyebrow}</p>
                )}
                <h3 className="text-display text-xl sm:text-3xl lg:text-4xl font-bold leading-tight">
                  {t.cta.title}
                </h3>
                <p className="mt-3 text-white/80 max-w-2xl">{t.cta.subtitle}</p>
              </div>
              <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3">
                <Button
                  variant="soft"
                  className="!bg-white !text-ink-900 hover:!bg-white !border-transparent justify-center"
                  icon={<Icon name="arrowRight" size={14} />}
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  {t.cta.primary}
                </Button>
                <Button
                  variant="ghost"
                  className="!text-white !border-white/30 hover:!bg-white/10 justify-center"
                  icon={<Icon name="mail" size={14} />}
                  iconPosition="left"
                  href="mailto:info@emfa-it.de"
                >
                  {t.cta.secondary}
                </Button>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CTA;
